import Alpine from 'alpinejs';

Alpine.data('header', () => ({
  scrolled: false,
  pinned: false,
  blocked: false,

  //ew
  hasHero: false,

  init() {
    this.hasHero = document.querySelector('main:has(.grid-template-hero)');

    if (! this.hasHero) {
      this.pinned = true;
    }

    this.scrolled = (window.scrollY > 0);
  },

  events: {
    ['x-on:header:pin']() {
      this.pinned = true;
    },
    // Blurring the nav requests unpinning, so we only unpin if we have a hero
    ['x-on:header:unpin']() {
      if (! this.hasHero) {
        return;
      }
      
      this.pinned = false;
    },
    ['x-on:header:block']() {
      this.blocked = true;
    },
    ['x-on:header:unblock']() {
      this.blocked = false;
    },
    // scroll to top requests unpinning, so we only unpin if we have a hero
    ['x-on:scroll.window']() {
      if (! this.hasHero) {
        return;
      }

      this.scrolled = (window.scrollY > 0);
    },
  },

  get classList() {
    return {
      'is-opaque': this.scrolled || this.pinned,
      'is-transparent': !this.scrolled && !this.pinned,
      'after:bg-black/50': this.blocked,
    };
  }
}));